var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoResponsive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 171,
  height: 40,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo-responsive_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M170.494 17.838a1.735 1.735 0 0 1 .505 1.243 1.74 1.74 0 0 1-.505 1.243c-.155.168-.341.3-.548.39s-.429.136-.653.133a1.6 1.6 0 0 1-.653-.132 1.6 1.6 0 0 1-.549-.39 1.74 1.74 0 0 1-.487-1.243 1.74 1.74 0 0 1 .487-1.244c.157-.164.344-.294.551-.38.206-.087.428-.13.651-.125.223-.005.444.038.651.124.206.087.394.217.55.38m-.104 2.378a1.57 1.57 0 0 0 .435-1.135 1.583 1.583 0 0 0-.435-1.135 1.5 1.5 0 0 0-.502-.352 1.45 1.45 0 0 0-.595-.117 1.44 1.44 0 0 0-1.08.469 1.6 1.6 0 0 0-.452 1.135 1.605 1.605 0 0 0 .452 1.135 1.442 1.442 0 0 0 1.08.468c.204.004.406-.036.595-.116a1.5 1.5 0 0 0 .502-.352m-.662-.919.366.685h-.47l-.279-.576h-.209v.576h-.435V18.18h.644a.6.6 0 0 1 .47.18q.095.073.146.183a.5.5 0 0 1 .046.232.6.6 0 0 1-.066.303.55.55 0 0 1-.213.22m-.592-.27h.209a.34.34 0 0 0 .192 0 .26.26 0 0 0 0-.162c0-.144 0-.216-.244-.216h-.192zM69.333 16.36a5.62 5.62 0 0 1 1.288 3.874v7.946H67.4V20.47a2.75 2.75 0 0 0-.557-1.802 2 2 0 0 0-.7-.49 1.9 1.9 0 0 0-.832-.14 2.1 2.1 0 0 0-.954.16 2.14 2.14 0 0 0-.788.578 3.44 3.44 0 0 0-.609 2.18v7.207H59.74v-7.711a2.75 2.75 0 0 0-.54-1.802 2 2 0 0 0-.708-.49 1.94 1.94 0 0 0-.841-.14 2.06 2.06 0 0 0-.954.158 2.1 2.1 0 0 0-.788.58 3.23 3.23 0 0 0-.644 2.18v7.207h-3.221v-12.9h3.221v1.369a3.95 3.95 0 0 1 1.508-1.383 3.8 3.8 0 0 1 1.974-.419 3.6 3.6 0 0 1 1.99.387 3.74 3.74 0 0 1 1.493 1.415 4.27 4.27 0 0 1 1.637-1.401 4.1 4.1 0 0 1 2.089-.401 4.3 4.3 0 0 1 1.897.318c.602.25 1.143.633 1.585 1.123M84.813 15.28v12.9h-3.221V26.74a4.17 4.17 0 0 1-1.623 1.41c-.65.317-1.37.451-2.086.392a4.4 4.4 0 0 1-1.83-.338 4.5 4.5 0 0 1-1.548-1.068 5.45 5.45 0 0 1-1.05-1.825 5.6 5.6 0 0 1-.29-2.103V15.28h3.22v7.514c-.023.358.026.717.142 1.055.117.338.3.647.538.909.23.229.504.408.803.525s.618.172.938.16c.366.021.733-.038 1.075-.175s.653-.348.91-.618a3.4 3.4 0 0 0 .749-2.397V15.28zM90.995 9.333h-3.222V28.18h3.222zM98.236 18.469v5.405a1.4 1.4 0 0 0 .33.991 1.5 1.5 0 0 0 .958.342q.767.042 1.532 0v3.01a6.47 6.47 0 0 1-4.666-.65 4.3 4.3 0 0 1-1.115-1.675 4.4 4.4 0 0 1-.243-2.018v-5.405h-2.176v-3.19h2.176v-3.603h3.204v3.603h2.82v3.19zM106.561 15.262h-3.221V28.18h3.221zM112.862 28.054a6.1 6.1 0 0 1-2.124-1.478 6.6 6.6 0 0 1-1.424-2.222 6.8 6.8 0 0 1-.456-2.624 6.8 6.8 0 0 1 .456-2.625 6.6 6.6 0 0 1 1.424-2.222 6.3 6.3 0 0 1 2.152-1.491 6.1 6.1 0 0 1 2.549-.473 6.24 6.24 0 0 1 3.326.9 5.95 5.95 0 0 1 2.263 2.415l-2.768 1.694a2.94 2.94 0 0 0-1.132-1.28 3.25 3.25 0 0 0-1.741-.45 3.1 3.1 0 0 0-1.294.236c-.41.17-.782.427-1.092.755a3.67 3.67 0 0 0-.957 2.54c-.011.466.068.929.233 1.362.164.433.411.828.724 1.161.312.324.685.58 1.095.75s.849.252 1.291.241a3.27 3.27 0 0 0 1.741-.45c.495-.289.89-.73 1.132-1.262l2.803 1.658a6.4 6.4 0 0 1-2.211 2.432 6.26 6.26 0 0 1-3.326.92 6.7 6.7 0 0 1-2.577-.487M126.008 15.262h-3.221V28.18h3.221zM139.259 16.324c.464.53.821 1.151 1.051 1.825.23.675.329 1.39.29 2.103v7.928h-3.221v-7.513a2.7 2.7 0 0 0-.141-1.056 2.6 2.6 0 0 0-.538-.908 2.4 2.4 0 0 0-.804-.524 2.3 2.3 0 0 0-.937-.16 2.55 2.55 0 0 0-1.083.175 2.6 2.6 0 0 0-.92.617 3.4 3.4 0 0 0-.749 2.396v6.973h-3.221v-12.9h3.221v1.44a4.2 4.2 0 0 1 1.633-1.41 4.04 4.04 0 0 1 2.094-.391 4.4 4.4 0 0 1 1.83.337 4.5 4.5 0 0 1 1.547 1.068M149.583 25.532a3.2 3.2 0 0 0 1.549-.292 3.3 3.3 0 0 0 1.237-1.006l2.595 1.55a6.27 6.27 0 0 1-2.369 2.11 6 6 0 0 1-3.064.647 6.6 6.6 0 0 1-2.68-.438 6.75 6.75 0 0 1-2.3-1.49 6.7 6.7 0 0 1-1.415-2.244 6.9 6.9 0 0 1-.448-2.64 6.9 6.9 0 0 1 .442-2.627 6.7 6.7 0 0 1 1.404-2.237 6.3 6.3 0 0 1 2.171-1.486 6.2 6.2 0 0 1 2.565-.46 5.8 5.8 0 0 1 2.466.468 5.95 5.95 0 0 1 2.061 1.478 6.95 6.95 0 0 1 1.741 4.865q0 .691-.122 1.37h-9.419a3.33 3.33 0 0 0 1.305 1.884c.639.446 1.411.64 2.177.547zm2.682-5.01a3.05 3.05 0 0 0-1.132-1.963 3.2 3.2 0 0 0-1.967-.649 3.27 3.27 0 0 0-2.142.685 3.26 3.26 0 0 0-1.114 1.928zM160.971 19.784q.774.36 1.602.558.967.255 1.898.631c.636.26 1.194.689 1.619 1.243.447.638.679 1.41.662 2.198a3.7 3.7 0 0 1-.351 1.72 3.6 3.6 0 0 1-1.095 1.343 5.76 5.76 0 0 1-3.586 1.064 5.08 5.08 0 0 1-3.08-.678 5.34 5.34 0 0 1-2.144-2.386l2.803-1.64c.152.533.479.994.924 1.303.445.31.981.448 1.514.392 1.149 0 1.741-.379 1.741-1.118 0-.342-.209-.63-.661-.846a12 12 0 0 0-1.602-.577 13 13 0 0 1-1.898-.649 3.84 3.84 0 0 1-1.602-1.225 3.23 3.23 0 0 1-.662-2.108 3.7 3.7 0 0 1 .317-1.65c.23-.518.575-.97 1.007-1.323a5.22 5.22 0 0 1 3.377-1.081 5.56 5.56 0 0 1 2.769.703 5.07 5.07 0 0 1 1.967 2.036l-2.733 1.55a2.13 2.13 0 0 0-.798-.995 2.02 2.02 0 0 0-1.205-.339 1.9 1.9 0 0 0-1.044.288.9.9 0 0 0-.296.335.95.95 0 0 0-.105.44c0 .342.209.63.662.847"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo-responsive_svg__b)",
  d: "M30.663 0c-.64.004-1.27.185-1.82.524a3.7 3.7 0 0 0-1.314 1.404l-8.01 16.216 10.83 21.892h8.706V0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo-responsive_svg__c)",
  d: "M0 40h8.706L19.553 18.11l-8.01-16.217A3.56 3.56 0 0 0 10.252.464a3.4 3.4 0 0 0-1.824-.518H.035"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo-responsive_svg__d)",
  d: "M8.672 40h21.677L19.502 17.964z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo-responsive_svg__e)",
  d: "M106.943 11.745v-.138a1.985 1.985 0 0 0-3.97 0v.138a1.985 1.985 0 1 0 3.97 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo-responsive_svg__f)",
  d: "M126.374 11.745v-.138a1.985 1.985 0 0 0-3.97 0v.138a1.985 1.985 0 0 0 3.97 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo-responsive_svg__b",
  x1: 38.305,
  x2: 38.305,
  y1: 13.153,
  y2: 39.279,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#14D7CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#02A8D7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo-responsive_svg__c",
  x1: 6.965,
  x2: 6.965,
  y1: -0.36,
  y2: 39.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9D500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "orange"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo-responsive_svg__d",
  x1: 19.519,
  x2: 19.519,
  y1: 21.441,
  y2: 43.243,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F16C8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#E65494"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C63894"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo-responsive_svg__e",
  x1: -4672.36,
  x2: -4663.3,
  y1: -5699.82,
  y2: -5699.82,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F16C8F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#E65494"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C63894"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo-responsive_svg__f",
  x1: 120.45,
  x2: 124.42,
  y1: 9.425,
  y2: 9.425,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00ABBF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#00A3C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0094C5"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-responsive_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h171v40H0z"
})))));
export default SvgLogoResponsive;